import React from "react";
import Hero from "../components/Hero";
import EditorialMarquee from "../components/EditorialMarquee";
import Products from "../components/Products";
import WhyUs from "../components/WhyUs";
import Manifesto from "../components/Manifesto";

export default function Landing() {
  return (
    <main>
      <Hero />
      <EditorialMarquee />
      <Products />
      <WhyUs />
      <Manifesto />
    </main>
  );
}
